export default __webpack_public_path__ + "static/media/Cube.a79da7aa.png";